import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import CashbackPresenter, {
  QUARANTINED_REASONS,
} from '../../../../presenters/CashbackPresenter';
import Row from '../../../../components/Row';
import Column from '../../../../components/Column';
import Flash from '../../../../components/forms/Flash';
import Label from '../../../../components/Label';
import Select from '../../../../components/Select';

const StateChangeForm = (props) => {
  const {
    values,
    handleSubmit,
    setFieldValue,
    errors,
    onModalClose,
    availableStates,
  } = props;
  const statesOptions = availableStates.map((state) => {
    return {
      label: state,
      value: state,
    };
  });

  const reasonOptions = Object.values(QUARANTINED_REASONS).map((reason) => {
    return {
      label: CashbackPresenter.quarantinedReasonReadable({
        quarantinedReason: reason,
      }),
      value: reason,
    };
  });
  const defaultReasonOption = { value: '', label: '-- select a reason --' };

  const handleChange = ({ target }) => {
    const { id, value } = target;

    setFieldValue(id, value);
  };

  const { state, quarantinedReason } = values;

  return (
    <form onSubmit={handleSubmit}>
      {!isNil(errors) && <Flash response={errors} />}
      <Row>
        <Column className="cashback-field-column">
          <Label name="state" title="State" errors={errors} />
          <Select
            id="state"
            value={state}
            onChange={handleChange}
            options={statesOptions}
            required
          />
        </Column>
      </Row>
      {CashbackPresenter.isQuarantined(values) && (
        <Row>
          <Column className="cashback-field-column">
            <Label name="quarantinedReason" title="Reason" errors={errors} />
            <Select
              id="quarantinedReason"
              onChange={handleChange}
              value={quarantinedReason}
              options={reasonOptions}
              defaultOption={defaultReasonOption}
              required
            />
          </Column>
        </Row>
      )}
      <div className="modal-actions">
        <button className="modal-save" type="submit">
          Save Changes
        </button>
        <button className="modal-close" onClick={onModalClose}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default StateChangeForm;

StateChangeForm.propTypes = {
  values: CashbackPresenter.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  availableStates: PropTypes.arrayOf(PropTypes.string).isRequired,
};

StateChangeForm.defaultProps = {
  errors: {},
};
